// Import our custom CSS
import './style/supercraft.sass'

import setupScrollWatch from "@/scrollTools";
import {setupTracing} from "@/whoami";

import setupIcons from "@/Icons";
import setupCompatibilityHooks from "@/compatibility";
import setupPing from "./src/ping";
setupIcons();

setupTracing();
setupScrollWatch();

document.addEventListener("DOMContentLoaded", function(){
    setupCompatibilityHooks();
    //setTimeout(setupPing, 500);

    let errorEl = document.getElementById("form-last-error");
    if(errorEl && window['_p_form_error']) {
        console.log("last error:",  window['_p_form_error']);
        errorEl.textContent = window['_p_form_error'];
        errorEl.classList.remove("d-none");
        location.hash = "#form-start";
    }
    if( window['_p_form_data']){
        for(const k in  window['_p_form_data']){
            const inp = document.getElementsByName(k);
            if(inp){
                for(const el of inp){
                    el.value = window['_p_form_data'][k];
                }
            }
        }
    }
});
